/* Rulife product card — variant dropdown sync (2026-09-03: Best Price / Save-line hooks removed) */
if (!window.__rlVariantInit) {
  window.__rlVariantInit = true;
  (function () {
    function applyVariant(sel) {
      var card = sel.closest('.m-product-card'); if (!card) return;
      var opt = sel.options[sel.selectedIndex]; if (!opt) return;
      var input = card.querySelector('input[name="id"]'); if (input) input.value = sel.value;
      var cur = card.querySelector('.rl-cur-price'); if (cur && opt.dataset.price) cur.textContent = opt.dataset.price;
      var cmp = card.querySelector('.rl-cmp-price');
      if (cmp) {
        if (opt.dataset.oncompare === '1') { cmp.textContent = opt.dataset.compare; cmp.style.display = ''; }
        else { cmp.style.display = 'none'; }
      }
      var badge = card.querySelector('.rl-pct-badge'), num = card.querySelector('.rl-pct-num');
      if (badge) {
        var p = parseInt(opt.dataset.pct || '0', 10);
        if (p > 0) { if (num) num.textContent = p + '%'; badge.style.display = ''; }
        else { badge.style.display = 'none'; }
      }
      if (opt.dataset.image) {
        var img = card.querySelector('.m-product-card__main-image img');
        if (img) { img.removeAttribute('srcset'); img.src = opt.dataset.image; }
      }
    }
    document.addEventListener('change', function (e) {
      var sel = e.target && e.target.closest ? e.target.closest('.rl-variant-select') : null;
      if (sel) applyVariant(sel);
    });
    function initAll() {
      var list = document.querySelectorAll('.rl-variant-select');
      for (var i = 0; i < list.length; i++) applyVariant(list[i]);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
  })();
}
